



























































































































































































import { computed, defineComponent, ref, Ref } from '@vue/composition-api'
// hooks
import { useHeadquarter, useEmployeesOp, useArea } from '@/hooks'

// componnents
import { PageHeader, AccordionFilters } from '@/components'
import { Select2, Select, DatePicker } from '@/components/general'

// types
import { ReportInternalAssistance, FilterReportInternalAssistance } from '@/models/reports/ReportInternalAssistance'

import { ReportInternalAssistanceService } from '@/services/reports'

// utils
import moment from 'moment'
import { alerts, getFullNameFormat } from '@/utils'

import ExcelJS from 'exceljs'

// constants
import {
  optionsWorkType,
  optionsWorkCategory
} from '@/constants'

export default defineComponent({
  name: 'ReportInternalAssistance',
  components: {
    PageHeader,
    Select2,
    Select,
    DatePicker,
    AccordionFilters
  },
  setup () {
    const ATTENDED = 'A'
    const ABSENT = 'X'
    const SUNDAY = 'D'
    const HOLIDAY = 'F'
    const MA = 'MA'
    const NUMBER = 'number'
    const title = 'Reporte de asistencia interna'
    const breadcrumbs = [
      {
        text: 'Dashboard',
        to: { name: 'home' }
      },
      {
        text: 'Reporte Asistencia Interna',
        active: true
      }
    ]
    const activeStatusOptions = [
      { value: 'active', text: 'Activos' },
      { value: 'inactive', text: 'Inactivos' }
    ]
    const activeStatus: Ref<string|null> = ref(null)
    const reportData: Ref<ReportInternalAssistance|null> = ref(null)
    const loading = ref(false)
    const filters: Ref<FilterReportInternalAssistance> = ref({
      headquarter: 0,
      date_init: '',
      date_end: '',
      activeStatus: '',
      work_type: null,
      work_category: null,
      area: null,
      sub_area: null,
      employees: []
    })
    const { loadingHeadquartes, getHeadquatersActivated, headquartersSelectOptions } = useHeadquarter()
    getHeadquatersActivated()

    const { areasOptions, getAreasActive, loadingAreas, areas } = useArea()
    getAreasActive()

    const subareaOptions = computed(() => {
      const areaSelected = areas.value.find(a => Number(a.id) === Number(filters.value.area))
      if (areaSelected) {
        return areaSelected.subAreas?.map(sub => {
          return {
            value: sub.id,
            text: sub.name
          }
        })
      }
      return []
    })

    const { employees, loadingEmployees } = useEmployeesOp()

    const allEmployees = computed(() => {
      return employees.value.map(employee => {
        return {
          value: employee.id,
          text: getFullNameFormat(employee)
        }
      })
    })

    const employeesOp = computed(() => {
      return employees.value.filter(employee => !filters.value.headquarter ? true : Number(employee.assignment.headquarter_id) === Number(filters.value.headquarter))
      .filter(employee => !filters.value.area ? true : Number(employee.assignment.area_id) === Number(filters.value.area))
      .filter(employee => !filters.value.sub_area ? true : Number(employee.assignment.sub_area_id) === Number(filters.value.sub_area))
      .filter(employee => !filters.value.activeStatus.value === 'active' ? employee.is_active : !employee.is_active)
      .map(employee => {
        return {
          value: employee.id,
          text: getFullNameFormat(employee)
        }
      })
    })

    const getAssistenceValue = (assistances, date) => {
      let html = ''
      const assistance = assistances.find(a => a.date === date)
      if (assistance) {
        const v = assistance.value
        const p = assistance.permiso
        switch (v) {
          case ABSENT:
            html = '<strong class="text-danger">X<br></strong>' + p
            break
          case ATTENDED:
            html = '<strong class="text-success"><i class="fas fa-check" /></i><span style="color: white">A</span><br></strong>' + p
            break
          case HOLIDAY:
            html = '<strong class="text-info">F<br></strong>' + p
            break
          case SUNDAY:
            html = '<strong class="text-warning">D<br></strong>' + p
            break
          case NUMBER:
            html = '<strong class="text-dark">' + p + '<br></strong>'
            break
          case MA:
            html = '<strong class="text-dark">MA<br></strong>'
            break
          default:
            html = ''
            break
        }
      }
      return html
    }

    const stripHtmlTags = (html) => {
      const tmp = document.createElement('div')
      tmp.innerHTML = html
      return tmp.textContent || tmp.innerText || ''
    }

    const generate = async () => {
      const { date_init, date_end, headquarter } = filters.value
      if (!date_init || !date_end || !headquarter) {
        alerts.error('Los campos de fecha y sede son obligatorios para generar el reporte.')
        return
      }
      loading.value = true
      reportData.value = await ReportInternalAssistanceService.getReportInternalAssistance(filters.value)
      loading.value = false
    }

    const exportToExcel = () => {
      const workbook = new ExcelJS.Workbook()
      const sheet = workbook.addWorksheet('Asistencia')

      // Establecer el formato de fecha específico de Excel
     // const excelDateFormat = 'dd/mm/yyyy;@'
      moment.locale('es')

      // Crear la fila de encabezado
      if (reportData.value && reportData.value.items) {
        const headerRow = sheet.addRow(['EMPLEADO', ...reportData.value.dates.map(date => {
          if (date.date === 'Asistencias') {
              return 'Total Asistencias'
          }
          if (date.date === 'Faltas') {
              return 'Faltas'
          }

          if (date.date === 'Vacaciones') {
              return 'Vacaciones'
          }

          if (date.date === 'D.M.') {
              return 'DM'
          }

          if (date.date === 'LCG') {
              return 'LCG'
          }

          if (date.date === 'LIP') {
              return 'LIP'
          }

          if (date.date === 'LSG') {
              return 'LSG'
          }

          if (date.date === 'MA') {
              return 'MA'
          }
          // console.log(date.date)
          const formattedDate = moment(date.date, 'YYYY-MM-DD').toDate()
          const dayName = moment(formattedDate).format('dddd') // Obtener el nombre del día
          return `${date.date_formatted} ${dayName}` // Agregar el nombre del día junto a la fecha formateada
        })])
        headerRow.eachCell(cell => {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FF007BFF' }
          }
          cell.font = {
            color: { argb: 'FFFFFFFF' },
            bold: true
          }
          cell.alignment = { horizontal: 'center', vertical: 'middle' }
        })
      }
      // Agregar los datos de asistencia
      if (reportData.value && reportData.value.items) {
        reportData.value.items.forEach(item => {
          const dataRow = sheet.addRow([getFullNameFormat(item.employee), ...item.assistances.map(assistance => {
            const formattedDate = moment(assistance.date, 'YYYY-MM-DD').toDate()
            formattedDate.setDate(formattedDate.getDate() + 1)
            const assistanceValue = stripHtmlTags(getAssistenceValue(item.assistances, assistance.date))
            return assistanceValue
          })])

          dataRow.eachCell(cell => {
            cell.alignment = { horizontal: 'center', vertical: 'middle' }
          })
        })
      }

      // Ajustar el ancho de las columnas automáticamente
      sheet.columns.forEach(column => {
        column.width = 18
      })

      // Configurar el encabezado de respuesta para descargar el archivo
      const contentDisposition = 'reporte_asistencia_interna.xlsx'
      const contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

      // Enviar el archivo al cliente
      workbook.xlsx.writeBuffer()
        .then(buffer => {
          const blob = new Blob([buffer], { type: contentType })
          const url = URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', contentDisposition)
          link.click()
          URL.revokeObjectURL(url)
        })
        .catch(error => {
          console.error('Error al exportar a Excel:', error)
        })
    }

    return {
      title,
      breadcrumbs,
      loadingHeadquartes,
      headquartersSelectOptions,
      exportToExcel,
      filters,
      optionsWorkType,
      optionsWorkCategory,
      allEmployees,
      employeesOp,
      loadingEmployees,
      generate,
      loading,
      moment,
      areasOptions,
      loadingAreas,
      subareaOptions,
      reportData,
      getFullNameFormat,
      ATTENDED,
      ABSENT,
      HOLIDAY,
      SUNDAY,
      getAssistenceValue,
      activeStatus,
      activeStatusOptions
    }
  }
})
